import React from "react";
import { motion } from "framer-motion";
import { lineReveal } from "@/lib/motion";

/**
 * Masked line-by-line reveal. Pass an array of lines (strings or nodes).
 */
export default function MaskedLines({ lines, className = "", lineClassName = "", startDelay = 0 }) {
  return (
    <span className={`block ${className}`}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em]">
          <motion.span
            className={`block ${lineClassName}`}
            variants={lineReveal}
            initial="hidden"
            animate="show"
            custom={i + startDelay}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}

export function MaskedLinesInView({ lines, className = "", lineClassName = "" }) {
  return (
    <motion.span className={`block ${className}`} initial="hidden" whileInView="show" viewport={{ once: true, amount: 0.4 }}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em]">
          <motion.span className={`block ${lineClassName}`} variants={lineReveal} custom={i}>
            {line}
          </motion.span>
        </span>
      ))}
    </motion.span>
  );
}
